import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ESamparkComponent } from './e-sampark/e-sampark.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { FrameworkModule } from 'framework';
import { CommonSharingService } from './services/common-sharing.service';
import { EsamparkServiceService } from './services/esampark-service.service';
import { MAT_DATE_LOCALE, MatCardModule } from '@angular/material';
import {MatToolbarModule} from '@angular/material/toolbar'; 
import { FilterPipe } from './filter-pipe/filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ESamparkComponent,
    FilterPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    MatSnackBarModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,MatDialogModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxSpinnerModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    MatDialogModule,
    MatDatepickerModule,
    MatIconModule,
    FlexLayoutModule,
    CommonModule,
    AppRoutingModule,
    FrameworkModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatCardModule
  ],
  providers: [
    CommonSharingService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {provide : LocationStrategy,useClass :HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
